import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  grid-row-start: 3;
  grid-row-end: 4;
  background-color: #1aacd9;
  border-bottom-left-radius: 23px;
  border-bottom-right-radius: 23px;
`;

const Footer = (props) => {
  return <Wrapper></Wrapper>;
};

export default Footer;
